/* AP mobile menu (header drawer), 2026-10-09 preview. Markup: snippets/ap-mobile-menu.liquid.
   - one shopping section open at a time; the open one is remembered for this visit
   - taps are logged with window.apTrack (snippets/ap-track.liquid): event "mobile_menu_tap",
     props {section, item}; no PII */
(function () {
  var nav = document.querySelector('[data-apmd]');
  if (!nav || nav.dataset.apmdReady) return;
  nav.dataset.apmdReady = '1';

  var KEY = 'apmd-open';
  var accs = Array.prototype.slice.call(nav.querySelectorAll('[data-apmd-acc]'));
  var saved = null;
  try { saved = sessionStorage.getItem(KEY); } catch (e) {}
  accs.forEach(function (d) {
    if (saved && d.getAttribute('data-apmd-acc') === saved) d.open = true;
    d.addEventListener('toggle', function () {
      if (d.open) {
        accs.forEach(function (o) { if (o !== d && o.open) o.open = false; });
        try { sessionStorage.setItem(KEY, d.getAttribute('data-apmd-acc')); } catch (e) {}
        track('section_open', d.getAttribute('data-apmd-acc'));
      } else if (!accs.some(function (o) { return o.open; })) {
        try { sessionStorage.removeItem(KEY); } catch (e) {}
      }
    });
  });

  function track(section, item) {
    if (typeof window.apTrack !== 'function') return;
    try { window.apTrack('mobile_menu_tap', { section: String(section).slice(0, 60), item: String(item || '').slice(0, 80) }, 'mobile_menu'); } catch (e) {}
  }
  nav.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (!a || !nav.contains(a)) return;
    var holder = a.closest('[data-apmd-track]');
    var section = (a.getAttribute('data-apmd-track') || (holder && holder.getAttribute('data-apmd-track')) || 'other');
    var label = (a.querySelector('.apmm__tile-title, .apmd__cat-title, .apmd__helper-title, .apmd__member-title, span') || a).textContent.trim();
    track(section, label);
  });
  // Chip rows: drop the edge fade once scrolled to the end; bring the current chip into view.
  Array.prototype.forEach.call(nav.querySelectorAll('.apmd__chips'), function (row) {
    function edge() { row.classList.toggle('is-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 4); }
    row.addEventListener('scroll', edge, { passive: true });
    var cur = row.querySelector('.is-current');
    var acc = row.closest('details');
    function settle() {
      if (cur) row.scrollLeft = Math.max(0, cur.parentElement.offsetLeft - row.offsetLeft - 20);
      edge();
    }
    if (acc) acc.addEventListener('toggle', function () { if (acc.open) requestAnimationFrame(settle); });
    settle();
  });
  var search = nav.querySelector('.apmd__search');
  if (search) search.addEventListener('submit', function () { track('search', 'submit'); });
})();
